var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2928 1.60958C30.7869 1.09956 30.1851 0.694744 29.522 0.418488C28.8589 0.142231 28.1477 0 27.4293 0C26.711 0 25.9998 0.142231 25.3367 0.418488C24.6736 0.694744 24.0718 1.09956 23.5659 1.60958L12.6829 12.4925L9.30923 9.0644C8.80338 8.55438 8.20154 8.14956 7.53844 7.87331C6.87535 7.59705 6.16412 7.45482 5.44578 7.45482C4.72744 7.45482 4.01622 7.59705 3.35312 7.87331C2.69003 8.14956 2.08819 8.55438 1.58234 9.0644C0.568856 10.0839 0 11.4631 0 12.9006C0 14.3382 0.568856 15.7173 1.58234 16.7369L8.87391 24.0285C9.89344 25.0419 11.2726 25.6108 12.7101 25.6108C14.1477 25.6108 15.5269 25.0419 16.5464 24.0285L31.0751 9.49972C31.6245 9.0063 32.0677 8.40622 32.3778 7.73603C32.6878 7.06583 32.8582 6.33955 32.8786 5.6014C32.8989 4.86324 32.7688 4.12867 32.4962 3.4424C32.2236 2.75613 31.8141 2.13254 31.2928 1.60958Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.46df17e10a500e99266eed277f26d007.svg";
export { ForwardRef as ReactComponent };